/**
 * Status values for the Price Gap Report. The enum values are the exact user-facing strings
 * shown in the report and written to the CSV "Status" column.
 */
enum PriceGapStatusEnum {
    NO_PRICE_UNDERCHARGING = "NO PRICE — UNDERCHARGING",
    NO_PRICE_OVERCHARGING = "NO PRICE — OVERCHARGING",
    NO_PRICE_NO_MSRP = "NO PRICE — NO MSRP",
    PRICE_SET_MISMATCH = "PRICE SET — MISMATCH",
    INCONSISTENT_HISTORY = "INCONSISTENT HISTORY",
    OK = "OK",
}

export default PriceGapStatusEnum;
